import React from 'react';
import { useTranslation } from 'react-i18next';
import { Label } from '@/shared/components/ui/Label';
import { Checkbox } from '@/shared/components/ui/Checkbox';
import { cn } from '@/shared/utils/utils';

interface ShowCompletedToggleProps {
  showCompleted: boolean;
  onToggle: (show: boolean) => void;
  className?: string;
}

export const ShowCompletedToggle: React.FC<ShowCompletedToggleProps> = ({
  showCompleted,
  onToggle,
  className,
}) => {
  const { t } = useTranslation('goals');

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <Checkbox
        id="show-completed"
        checked={showCompleted}
        onCheckedChange={(checked) => onToggle(checked === true)}
        className="cursor-pointer border-black"
      />
      <Label
        htmlFor="show-completed"
        className="text-sm text-muted-foreground cursor-pointer whitespace-nowrap"
      >
        {t('showCompleted')}
      </Label>
    </div>
  );
};
